export class FlowNestedRejectedError extends Error {
  constructor(message = 'Nested analytics flow rejected') {
    super(message);
    this.name = 'FlowNestedRejectedError';
  }
}

export function isFlowNestedRejectedError(error: unknown): error is FlowNestedRejectedError {
  return error instanceof Error && error.name === 'FlowNestedRejectedError';
}
